// ─────────────────────────────────────────────────────────────
// REPORT REGION TAXONOMY
// ─────────────────────────────────────────────────────────────
// This is the single source of truth for the four report "tracks"
// published every week: one global report, three regional reports.
//
// It's used in two places:
//   1. The UI (ReportCard, ReportsFilterBar) — title/summary/color/icon
//   2. The Drive filename parser (utils/parseReportFile.js) — each
//      region's `keywords` are matched (case-insensitively) against
//      the part of the filename after the date to figure out which
//      region a given PDF belongs to. No match -> falls back to
//      "global". See utils/parseReportFile.js for the matching logic.
//
// To add a region: add an entry here (with its keywords) and add a
// matching icon in components/reports/ReportCard.js's REGION_ICONS map.
// Nothing else needs to change.
// ─────────────────────────────────────────────────────────────

export const REPORT_REGIONS = [
  {
    key: "global",
    title: "Global Impact Report",
    summary: "Global energy market status, risks and economic impact.",
    color: "#1976D2",
    icon: "globe",
    // fallback used whenever no other region's keywords match.
    keywords: ["global"],
  },
  {
    key: "asia",
    title: "Asia Regional Report",
    summary: "Asia energy exposure, pricing and economic implications.",
    color: "#2E7D32",
    icon: "asia",
    keywords: ["asia"],
  },
  {
    key: "middle-east",
    title: "Middle East Report",
    summary: "GCC, Iran, Egypt, East Med and regional impacts.",
    color: "#E65100",
    icon: "middle-east",
    keywords: ["middle east", "mena", "gcc"],
  },
  {
    key: "sub-saharan-africa",
    title: "Sub-Saharan Africa Report",
    summary: "East, West and Southern Africa energy and economic impact.",
    color: "#7B1FA2",
    icon: "africa",
    keywords: ["sub-saharan africa", "sub saharan africa", "africa"],
  },
]

// "Week of 1 July 2026"
export const formatWeekLabel = (isoDate) => {
  const date_start = new Date(`${isoDate}T00:00:00`)
  const date_end = new Date(new Date(date_start).setDate(date_start.getDate() + 6));

  const day_start = date_start.getDate()
  const day_end = date_end.getDate()

  const month_start = date_start.toLocaleDateString("en-US", { month: "long" })
  const month_end = date_end.toLocaleDateString("en-US", { month: "long" })

  const year_start = date_start.getFullYear()
  const year_end = date_end.getFullYear()

  if(year_start != year_end)
    return `Week of ${day_start} ${month_start} ${year_start} to ${day_end} ${month_end} ${year_end}`
  else
    return `Week of ${day_start} ${month_start} to ${day_end} ${month_end} ${year_end}`
}

export default REPORT_REGIONS
